import { render, staticRenderFns } from "./SupportCard.vue?vue&type=template&id=3575898a&scoped=true&"
import script from "./SupportCard.vue?vue&type=script&lang=js&"
export * from "./SupportCard.vue?vue&type=script&lang=js&"
import style0 from "./SupportCard.vue?vue&type=style&index=0&id=3575898a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3575898a",
  null
  
)

export default component.exports